// Top-level shell: header, tab switcher, error banner. Owns the active
// tab; the two tabs (Imports, Browser) own their own data fetching.

import { useEffect, useState } from 'react';
import { api, WhoAmI } from './api';
import Imports from './Imports';
import Browser from './Browser';

type Tab = 'imports' | 'browser';

export default function App() {
  const [tab, setTab] = useState<Tab>('imports');
  const [whoami, setWhoami] = useState<WhoAmI | null>(null);
  const [bootErr, setBootErr] = useState<string | null>(null);

  useEffect(() => {
    api.whoami()
      .then(setWhoami)
      .catch((e) => setBootErr(String(e)));
  }, []);

  return (
    <div className="app-shell">
      <header className="app-header">
        <h1>data — research corpus manager</h1>
        <span className="meta">
          {whoami
            ? `bucket=${whoami.bucket} · cap=${whoami.size_cap_str}`
            : bootErr
            ? 'unreachable'
            : '…'}
        </span>
      </header>

      {bootErr && <div className="error-banner">{bootErr}</div>}

      <div className="tabs">
        <button
          className={`tab ${tab === 'imports' ? 'active' : ''}`}
          onClick={() => setTab('imports')}
        >
          Imports
        </button>
        <button
          className={`tab ${tab === 'browser' ? 'active' : ''}`}
          onClick={() => setTab('browser')}
        >
          Browser
        </button>
      </div>

      {tab === 'imports' && <Imports />}
      {tab === 'browser' && <Browser />}
    </div>
  );
}
